import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button, Loader } from '@pocketlaw/tetris';
import { useEsigning } from 'app/domains/esigning/components/EsigningProvider';
import { useEsigningCredits } from 'app/domains/esigning/hooks/useEsigningCredits';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { useUnsupportedRecipientValues } from 'app/domains/esigning/hooks/useUnsupportedRecipientValues';
import { usePDFData } from 'shared/domains/documents';
import { CreditsErrorAlert } from './CreditsErrorAlert';
import { InvalidValues } from './InvalidValues';
import { NoCreditsAlert } from './NoCreditsAlert';
import { PasswordProtectedPdfAlert } from './PasswordProtectedPdfAlert';
import { RestrictedPermissionsPdfAlert } from './RestrictedPermissionsPdfAlert';
import { SigningOrderAlert } from './SigningOrderAlert';
export function SendButton() {
    const { allRecipients, signerRecipients } = useEsigningRecipients();
    const { properties } = useEsigningProviderMetadata();
    const { showCreditBalance } = properties;
    const { submittingCreation, sendDocumentForEsigning } = useEsigning();
    const pdfData = usePDFData();
    const { availableCredits, loading: loadingCredits, error: creditsError } = useEsigningCredits();
    const { isAuthenticationModeUnsupported, isNameFormatUnsupported } = useUnsupportedRecipientValues();
    const unsupportedAuthenticationMode = allRecipients.some(isAuthenticationModeUnsupported);
    const unsupportedNameFormat = allRecipients.some(isNameFormatUnsupported);
    const hasNoCredits = showCreditBalance && availableCredits === 0;
    const hasRestrictedPermissions = (pdfData === null || pdfData === void 0 ? void 0 : pdfData.hasRestrictedPermissions) || false;
    const isPasswordProtected = (pdfData === null || pdfData === void 0 ? void 0 : pdfData.passwordProtected) || false;
    const signersWithInvalidValues = unsupportedAuthenticationMode || unsupportedNameFormat;
    const submitDisabled = isPasswordProtected ||
        submittingCreation ||
        loadingCredits ||
        hasNoCredits ||
        !signerRecipients.length ||
        signersWithInvalidValues;
    const getButtonContent = () => {
        if (submittingCreation) {
            return (<Fragment>
          <Trans comment="Label for loading when sending document for e-signing">Sending for e-signing</Trans>
          <Loader />
        </Fragment>);
        }
        return <Trans comment="Label for sending document for e-signing">Send for e-signing</Trans>;
    };
    return (<Fragment>
      {isPasswordProtected && <PasswordProtectedPdfAlert />}
      {hasRestrictedPermissions && !isPasswordProtected && <RestrictedPermissionsPdfAlert />}
      {showCreditBalance && (<Fragment>
          {!loadingCredits && hasNoCredits && !creditsError && <NoCreditsAlert />}
          {!loadingCredits && creditsError && <CreditsErrorAlert />}
        </Fragment>)}
      <SigningOrderAlert />
      <InvalidValues unsupportedAuthenticationMode={unsupportedAuthenticationMode} unsupportedNameFormat={unsupportedNameFormat}/>
      <Button $stretch type="submit" appearance="primary" disabled={submitDisabled} onClick={sendDocumentForEsigning}>
        {getButtonContent()}
      </Button>
    </Fragment>);
}
